import { Box, Grid, GridBoxList } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import payrollPolicies from 'modules/payroll_bundle/store/collections/policies'

import PayrollPolicyItem from 'modules/payroll_bundle/pages/settings/Content/PayrollPolicies/components/PayrollPolicyItem'

interface Props {
  policyEmployeeCounts: Map<number, number>
}

const Content = ({ policyEmployeeCounts }: Props) => {
  const { loading } = useAsyncData(() => {
    return payrollPolicies.fetch()
  }, [])

  if (loading) return <Loading />

  const payrollPolicyItems = payrollPolicies.models.map((payrollPolicy) => {
    const policyId = Number(payrollPolicy.get('id'))
    const employeeCount = policyEmployeeCounts.get(policyId) ?? 0

    return (
      <PayrollPolicyItem
        key={policyId}
        payrollPolicy={payrollPolicy}
        employeeCount={employeeCount}
      />
    )
  })

  if (payrollPolicies.models.length > 1) {
    return <Grid variant="small">{payrollPolicyItems}</Grid>
  }

  if (payrollPolicies.models.length === 1) {
    return <Box>{payrollPolicyItems}</Box>
  }

  return (
    <GridBoxList centered={payrollPolicies.models.length < 2}>{payrollPolicyItems}</GridBoxList>
  )
}

export default observer(Content)
